exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userGroupInvitationsWrapper table{min-width:1400px}.userGroupInvitationsWrapper table td,.userGroupInvitationsWrapper table th{font-size:.75rem}.authorizerChildGroupSelectWrapper .multiselect__tags{height:35px;min-height:35px;padding-top:4px;margin-top:2px;border:1px solid #ced4da;font-size:13px}.authorizerChildGroupSelectWrapper .multiselect__placeholder{color:#495057}", ""]);

// exports
